import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "lib-flexible";

// import style
import "@styles/reset.css";
import "@styles/border.css";
import "@styles/main.css";
import "@styles/animate.css";
import "lib-flexible/flexible.js";

Vue.config.productionTip = false;

import { $http, $api } from "@javascript/axios.js";
import * as $unit from "@javascript/methods.js";

import ErrorPlugin from '@javascript/errorPlugin'//处理vue项目异常实战记录

window.eventBus = new Vue();
Object.assign(Vue.prototype, {
  $http,
  $api,
  $unit,
  $goto(obj, attr, boolean = true) {
      const { $router } = this;
      try {
          if (obj) {
              boolean ? $router[attr || "push"](obj) : window[attr || "open"](obj);
              return $router;
          }
      } catch (e) {
          console.log("$goto::::", e);
      }
  },
});
new Vue({
  router,
  store,
  ErrorPlugin,
  render: (h) => h(App),
}).$mount("#app");
